module.exports = __webpack_public_path__ + "assets/home_primary.d8f4586e.svg";